const DATE_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function renderRetreatDateHeader({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) {
  const thisYear = new Date().getFullYear();
  const selectedYear = date.getFullYear();
  const years = Array.from({ length: 90 }, (_, i) => thisYear + 6 - i);
  if (!years.includes(selectedYear)) years.push(selectedYear);
  years.sort((a, b) => a - b);

  return (
    <div className="rfm-date-head">
      <div className="rfm-date-selects">
        <select
          value={DATE_MONTHS[date.getMonth()]}
          onChange={({ target: { value } }) =>
            changeMonth(DATE_MONTHS.indexOf(value))
          }
        >
          {DATE_MONTHS.map((month) => (
            <option key={month} value={month}>
              {month}
            </option>
          ))}
        </select>
        <select
          value={String(date.getFullYear())}
          onChange={({ target: { value } }) => changeYear(Number(value))}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <div className="rfm-date-nav">
        <button
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          aria-label="Previous month"
        >
          {"<"}
        </button>
        <strong>
          {DATE_MONTHS[date.getMonth()]} {date.getFullYear()}
        </strong>
        <button
          type="button"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          aria-label="Next month"
        >
          {">"}
        </button>
      </div>
    </div>
  );
}
